import * as _ from 'lodash';
import { fromJS } from 'immutable';
import { SUCCESS, START, ERROR } from '../actions/global';
import * as rollCorrActions from '../actions/rollCorrection';
import { fetchingState } from '@constants';

// const updateStateArrayItem = (state, action, arrayName, idFieldName) =>
//   state.setIn(
//     [arrayName, 'data'],
//     fromJS(
//       state
//         .getIn([arrayName, 'data'])
//         .toJS()
//         .map(x =>
//           x[idFieldName] === _.get(action, `data.results[0].${idFieldName}`)
//             ? action.data.results[0]
//             : x,
//         ),
//     ),
//   );

const initialState = {
  rollCorrGroups: {
    data: [],
    state: null,
  },
  currRollCorrGroup: {
    data: {},
    state: null,
  },
  rollCorrJobs: {
    data: [],
    state: null,
  },
  rollCorrJobErrors: {
    data: [],
    totalRecords: 0,
    state: null,
  },
  availableYears: {
    data: [],
    state: null,
  },
  pagination: {
    count: 0,
    page: 1,
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100, 1000],
  },
  taxLimitationFreezesPagination: {
    count: 0,
    page: 1,
    rowsPerPage: 500,
    rowsPerPageOptions: [5, 10, 25, 50, 100, 500, 1000, 5000, 10000],
  },
  taxLimitationErrorsPagination: {
    count: 0,
    page: 1,
    rowsPerPage: 500,
    rowsPerPageOptions: [5, 10, 25, 50, 100, 500, 1000, 5000, 10000],
  },
  rollCorrGroupErrors: {
    data: [],
    totalRecords: 0,
    state: null,
  },
  rollCorrJobProperties: {
    data: [],
    totalRecords: 0,
    state: null,
  },
  rollCorrJobProcessed: {
    data: [],
    totalRecords: 0,
    state: null,
  },
};

export default (state = fromJS(initialState), action) => {
  switch (action.type) {
    case rollCorrActions.FETCH_ALL_ROLL_CORR_GROUPS[START]: {
      return state.setIn(['rollCorrGroups', 'state'], fetchingState.FETCHING);
    }
    case rollCorrActions.FETCH_ALL_ROLL_CORR_GROUPS[ERROR]: {
      return state.setIn(['rollCorrGroups', 'state'], fetchingState.ERROR);
    }
    case rollCorrActions.FETCH_ALL_ROLL_CORR_GROUPS[SUCCESS]: {
      return state
        .setIn(['rollCorrGroups', 'state'], fetchingState.LOADED)
        .setIn(
          ['rollCorrGroups', 'data'],
          fromJS(_.get(action, ['data', 'results'], [])),
        )
        .setIn(
          ['pagination', 'count'],
          _.get(action, ['data', 'results'], []).length,
        );
    }

    case rollCorrActions.FETCH_MASS_ROLL_CORRECTION_JOBS[START]: {
      return state.setIn(['rollCorrJobs', 'state'], fetchingState.FETCHING);
    }
    case rollCorrActions.FETCH_MASS_ROLL_CORRECTION_JOBS[ERROR]: {
      return state.setIn(['rollCorrJobs', 'state'], fetchingState.ERROR);
    }
    case rollCorrActions.FETCH_MASS_ROLL_CORRECTION_JOBS[SUCCESS]: {
      return state
        .setIn(['rollCorrJobs', 'state'], fetchingState.LOADED)
        .setIn(
          ['rollCorrJobs', 'data'],
          fromJS(_.get(action, ['data', 'results'], [])),
        );
    }

    case rollCorrActions.FETCH_ROLL_CORR_AVAILABLE_YEARS[START]: {
      return state.setIn(['availableYears', 'state'], fetchingState.FETCHING);
    }
    case rollCorrActions.FETCH_ROLL_CORR_AVAILABLE_YEARS[ERROR]: {
      return state.setIn(['availableYears', 'state'], fetchingState.ERROR);
    }
    case rollCorrActions.FETCH_ROLL_CORR_AVAILABLE_YEARS[SUCCESS]: {
      return state
        .setIn(['availableYears', 'state'], fetchingState.LOADED)
        .setIn(
          ['availableYears', 'data'],
          fromJS(_.get(action, ['data', 'results'], [])),
        );
    }

    case rollCorrActions.FETCH_MASS_ROLL_CORRECTION_JOB_ERRORS[START]: {
      return state.setIn(
        ['rollCorrJobErrors', 'state'],
        fetchingState.FETCHING,
      );
    }
    case rollCorrActions.FETCH_MASS_ROLL_CORRECTION_JOB_ERRORS[SUCCESS]: {
      return state
        .setIn(['rollCorrJobErrors', 'state'], fetchingState.LOADED)
        .setIn(
          ['rollCorrJobErrors', 'data'],
          fromJS(_.get(action, ['data', 'results', 'results'], [])),
        )
        .setIn(
          ['rollCorrJobErrors', 'totalRecords'],
          _.get(action, ['data', 'results', 'totalRecords'], 0),
        );
    }
    case rollCorrActions.FETCH_MASS_ROLL_CORRECTION_JOB_ERRORS[ERROR]: {
      return state.setIn(['rollCorrJobErrors', 'state'], fetchingState.ERROR);
    }
    case rollCorrActions.FETCH_MASS_ROLL_CORRECTION_JOB_PROPERTIES[START]: {
      return state.setIn(
        ['rollCorrJobProperties', 'state'],
        fetchingState.FETCHING,
      );
    }
    case rollCorrActions.FETCH_MASS_ROLL_CORRECTION_JOB_PROPERTIES[ERROR]: {
      return state.setIn(
        ['rollCorrJobProperties', 'state'],
        fetchingState.ERROR,
      );
    }
    case rollCorrActions.FETCH_MASS_ROLL_CORRECTION_JOB_PROPERTIES[SUCCESS]: {
      const results = _.get(action, ['data', 'results', 'results'], []);
      console.log('Properties results:', results); // Debug log
      return state
        .setIn(['rollCorrJobProperties', 'state'], fetchingState.LOADED)
        .setIn(
          ['rollCorrJobProperties', 'data'],
          fromJS(Array.isArray(results) ? results : []),
        )
        .setIn(
          ['rollCorrJobProperties', 'totalRecords'],
          _.get(action, ['data', 'results', 'totalRecords'], 0),
        );
    }
    case rollCorrActions.FETCH_MASS_ROLL_CORRECTION_JOB_PROCESSED[START]: {
      return state.setIn(
        ['rollCorrJobProcessed', 'state'],
        fetchingState.FETCHING,
      );
    }
    case rollCorrActions.FETCH_MASS_ROLL_CORRECTION_JOB_PROCESSED[ERROR]: {
      return state.setIn(
        ['rollCorrJobProcessed', 'state'],
        fetchingState.ERROR,
      );
    }
    case rollCorrActions.FETCH_MASS_ROLL_CORRECTION_JOB_PROCESSED[SUCCESS]: {
      const results = _.get(action, ['data', 'results', 'results'], []);
      console.log('Processed results:', results); // Debug log
      return state
        .setIn(['rollCorrJobProcessed', 'state'], fetchingState.LOADED)
        .setIn(
          ['rollCorrJobProcessed', 'data'],
          fromJS(Array.isArray(results) ? results : []),
        )
        .setIn(
          ['rollCorrJobProcessed', 'totalRecords'],
          _.get(action, ['data', 'results', 'totalRecords'], 0),
        );
    }
    case rollCorrActions.CHANGE_PAGE: {
      return state.setIn(['pagination', 'page'], action.payload);
    }
    case rollCorrActions.CHANGE_ROWS_PER_PAGE: {
      return state.setIn(['pagination', 'rowsPerPage'], action.payload);
    }
    case rollCorrActions.FETCH_ROLL_CORR_GROUP[START]: {
      return state.setIn(
        ['currRollCorrGroup', 'state'],
        fetchingState.FETCHING,
      );
    }
    case rollCorrActions.FETCH_ROLL_CORR_GROUP[ERROR]: {
      return state.setIn(['currRollCorrGroup', 'state'], fetchingState.ERROR);
    }
    case rollCorrActions.FETCH_ROLL_CORR_GROUP[SUCCESS]:
      return state
        .setIn(
          ['rollCorrGroups', 'data'],
          fromJS(
            state
              .getIn(['rollCorrGroups', 'data'])
              .toJS()
              .map((x) => {
                if (action?.data?.results?.length) {
                  for (let y = 0; y < action.data.results.length; y++) {
                    if (
                      x.rollCorrGroupID ===
                        _.get(action, `data.results[${y}].rollCorrGroupID`) &&
                      x.pRollCorr ===
                        _.get(action, `data.results[${y}].pRollCorr`) &&
                      x.pYear === _.get(action, `data.results[${y}].pYear`)
                    ) {
                      return action.data.results[y];
                    } else {
                      return x;
                    }
                  }
                }
                return x;
              }),
          ),
        )
        .setIn(
          ['currRollCorrGroup', 'data'],
          fromJS(_.get(action, ['data', 'results', 0], [])),
        )
        .setIn(['currRollCorrGroup', 'state'], fetchingState.LOADED);
    case rollCorrActions.RECALCULATE_ROLL_CORR_GROUP[START]: {
      return state.setIn(['recalculate', 'state'], fetchingState.FETCHING);
    }
    case rollCorrActions.RECALCULATE_ROLL_CORR_GROUP[ERROR]: {
      return state.setIn(['recalculate', 'state'], fetchingState.ERROR);
    }
    case rollCorrActions.RECALCULATE_ROLL_CORR_GROUP[SUCCESS]:
      return state
        .setIn(['recalculate', 'state'], fetchingState.LOADED)
        .setIn(
          ['recalculate', 'data'],
          fromJS(_.get(action, ['data', 'results'], [])),
        );

    case rollCorrActions.RECALCULATE_ROLL_CORR_GROUP_STATUS[START]: {
      return state.setIn(
        ['recalculateStatus', 'state'],
        fetchingState.FETCHING,
      );
    }
    case rollCorrActions.RECALCULATE_ROLL_CORR_GROUP_STATUS[ERROR]: {
      return state.setIn(['recalculateStatus', 'state'], fetchingState.ERROR);
    }
    case rollCorrActions.RECALCULATE_ROLL_CORR_GROUP_STATUS[SUCCESS]:
      return state
        .setIn(['recalculateStatus', 'state'], fetchingState.LOADED)
        .setIn(
          ['recalculateStatus', 'data'],
          fromJS(_.get(action, ['data', 'results'], [])),
        );
    case rollCorrActions.FETCH_GROUP_RECAPTURE_ERRORS[START]: {
      return state
        .setIn(['taxLimitationErrorsPagination', 'page'], action.page)
        .setIn(
          ['taxLimitationErrorsPagination', 'rowsPerPage'],
          action.pageSize,
        );
    }
    case rollCorrActions.FETCH_GROUP_RECAPTURE_ERRORS[SUCCESS]: {
      return state.setIn(
        ['taxLimitationErrorsPagination', 'count'],
        action.data.propertyCount,
      );
    }
    case rollCorrActions.FETCH_GROUP_RECAPTURE_FREEZES[START]: {
      return state
        .setIn(['taxLimitationFreezesPagination', 'page'], action.page)
        .setIn(
          ['taxLimitationFreezesPagination', 'rowsPerPage'],
          action.pageSize,
        );
    }
    case rollCorrActions.FETCH_GROUP_RECAPTURE_FREEZES[SUCCESS]: {
      return state.setIn(
        ['taxLimitationFreezesPagination', 'count'],
        action.data.propertyCount,
      );
    }
    case rollCorrActions.CHANGE_PAGE_RECAPTURE_ERRORS: {
      return state.setIn(
        ['taxLimitationErrorsPagination', 'page'],
        action.payload,
      );
    }
    case rollCorrActions.RESET_PAGE_RECAPTURE_FREEZES: {
      return state.setIn(['taxLimitationFreezesPagination', 'page'], 1);
    }
    case rollCorrActions.CHANGE_ROWS_PER_PAGE_RECAPTURE_ERRORS: {
      return state.setIn(
        ['taxLimitationErrorsPagination', 'rowsPerPage'],
        action.payload,
      );
    }
    case rollCorrActions.CHANGE_PAGE_RECAPTURE_FREEZES: {
      return state.setIn(
        ['taxLimitationFreezesPagination', 'page'],
        action.payload,
      );
    }
    case rollCorrActions.RESET_PAGE_RECAPTURE_ERRORS: {
      return state.setIn(['taxLimitationErrorsPagination', 'page'], 1);
    }
    case rollCorrActions.CHANGE_ROWS_PER_PAGE_RECAPTURE_FREEZES: {
      return state.setIn(
        ['taxLimitationFreezesPagination', 'rowsPerPage'],
        action.payload,
      );
    }

    case rollCorrActions.UPLOAD_FILE[SUCCESS]:
    case rollCorrActions.DELETE_FILE[SUCCESS]:
    case rollCorrActions.UPDATE_FILE[SUCCESS]:
      return state.setIn(
        ['rollCorrGroups', 'data'],
        fromJS(
          state
            .getIn(['rollCorrGroups', 'data'])
            .toJS()
            .map((group) =>
              group.rollCorrGroupID === action.data.results[0].rollCorrGroupID
                ? action.data.results[0]
                : group,
            ),
        ),
      );

    case rollCorrActions.FETCH_ROLL_CORR_GROUP_ERRORS[START]: {
      return state.setIn(
        ['rollCorrGroupErrors', 'state'],
        fetchingState.FETCHING,
      );
    }
    case rollCorrActions.FETCH_ROLL_CORR_GROUP_ERRORS[ERROR]: {
      return state.setIn(['rollCorrGroupErrors', 'state'], fetchingState.ERROR);
    }
    case rollCorrActions.FETCH_ROLL_CORR_GROUP_ERRORS[SUCCESS]: {
      return state
        .setIn(['rollCorrGroupErrors', 'state'], fetchingState.LOADED)
        .setIn(
          ['rollCorrGroupErrors', 'data'],
          fromJS(_.get(action, ['data', 'results'], [])),
        )
        .setIn(
          ['rollCorrGroupErrors', 'totalRecords'],
          _.get(action, 'data.errorCount', 0),
        );
    }
    default: {
      return state;
    }
  }
};
